import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction } from '../../serviceCall'

export const sendProCodeInviteLinkApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        formDataCommonFunction(data, apiConstants.MESSAGING.SEND_PRO_CODE_INVITE_LINK)
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 
